const LUMPSUM_DISPENSARY_AREA_MAP = {
  externalClinic: '1',
  generalCare: '3',
  pain: '12',
  remote: '60',
  remoteOverride: '52'
};

export default LUMPSUM_DISPENSARY_AREA_MAP;
